import styles from 'src/styles/Global.module.css'
import Head from "next/head";
import Link from "next/link";
import { useLanguage } from 'context/LanguageContext.js'

export function getStaticProps({locale}) {
	return { props: { ...(locale && {locale})  } }    
}

export default function Home({locale}) {

    const {adminLanguage} = useLanguage()

    return (
        <div className={styles.container}>
            <main className={styles.main}>
                <h1 className={styles.title}>
                    {adminLanguage.login["Welcome to ShopHub"]}
                </h1>
                <Link href={'/login'}>
                    <button
                        className={styles.button}
                        style={{maxWidth: "fit-content", padding: "1rem", fontSize: "1.6rem", margin: "50px"}}
                    >
                        {adminLanguage.login["Login / Install app"]}
                    </button>
                </Link>
            </main>
        </div>
    )
}